module.exports = __webpack_public_path__ + "img/remove-topic.6810061a.svg";